import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import IntlMessages from '../../components/utility/intlMessages';
import TopbarDropdownWrapper from './topbarDropdown.style';
import {
  IconButtons,
  TopbarDropdown,
  UserInformation,
  SettingsList,
  Icon,
} from './topbarDropdown.style';
import authAction from '../../redux/auth/actions';
import config from '../../settings';
import Avatar from '@material-ui/core/Avatar';

const { logout } = authAction;

class TopbarUser extends Component {
  state = {
    visible: false,
    anchorEl: null,
  };
  hide = () => {
    this.setState({ visible: false });
  };
  handleVisibleChange = () => {
    this.setState({
      visible: !this.state.visible,
      anchorEl: findDOMNode(this.button),
    });
  };
  render() {
    const { user_id, firstName, lastName, email, avtar } =
      this.props?.userProfile;
    const content = (
      <TopbarDropdown>
        <UserInformation>
          <div className="userImage">
            {avtar ? (
              <Avatar
                src={`${
                  avtar?.slice(0, 5) === 'avtar'
                    ? `${config.cdnUrl}/users/${user_id}/${avtar}`
                    : avtar
                }`}
                alt="user"
              />
            ) : (
              <Avatar src="" alt="user" />
            )}
          </div>

          <div className="userDetails">
            <h3>{`${firstName} ${lastName}`}</h3>
            <p>{email}</p>
          </div>
        </UserInformation>

        <SettingsList>
          <Link to="/dashboard/userProfile" className="dropdownLink">
            <Icon>settings</Icon>
            <IntlMessages id="themeSwitcher.settings" />
          </Link>
          <Link to="/" onClick={this.props.logout} className="dropdownLink">
            <Icon>input</Icon>
            <IntlMessages id="topbar.logout" />
          </Link>
        </SettingsList>
      </TopbarDropdown>
    );
    return (
      <div id="topbarUserIcon">
        <IconButtons
          ref={(node) => {
            this.button = node;
          }}
          onClick={this.handleVisibleChange}
        >
          <div className="userImgWrapper">
            {avtar ? (
              <Avatar
                src={`${
                  avtar?.slice(0, 5) === 'avtar'
                    ? `${config.cdnUrl}/users/${user_id}/${avtar}`
                    : avtar
                }`}
                alt="#"
              />
            ) : (
              <Avatar src="" alt="user" />
            )}
          </div>
        </IconButtons>

        <TopbarDropdownWrapper
          open={this.state.visible}
          anchorEl={this.state.anchorEl}
          onClose={this.hide}
          // marginThreshold={66}
          className="userPopover"
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
        >
          {content}
        </TopbarDropdownWrapper>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.App,
    userProfile: state.Auth,
    customizedTheme: state.ThemeSwitcher.topbarTheme,
  }),
  { logout }
)(TopbarUser);
